/** Shared chrome for the chat surfaces, so /whatsapp and /communication agree. */

export const WA_GREEN = "#25D366";
export const WA_HEADER_TEAL = "#008069";
export const WA_SIDEBAR_HEADER = "#f0f2f5";
export const WA_CHAT_BG = "#efeae2";
export const WA_OUT_BUBBLE = "#d9fdd3";

// Email gets its own skin so a glance at the thread tells you which channel
// you are in without reading the header.
export const EMAIL_BLUE = "#1a73e8";
export const EMAIL_HEADER = "#1f5fa9";
export const EMAIL_CHAT_BG = "#f5f7fa";
export const EMAIL_OUT_BUBBLE = "#e8f0fe";

// Website chat widget: violet, so it is not mistaken for either of the above.
export const CHAT_VIOLET = "#7c4dff";
export const CHAT_HEADER = "#5b36c9";
export const CHAT_BG = "#f6f3ff";
export const CHAT_OUT_BUBBLE = "#ebe4ff";

export const CHANNELS = {
  WHATSAPP: "whatsapp",
  EMAIL: "email",
  CHAT: "chat",
};

/**
 * Per-channel facts the inbox branches on, so adding a channel is one entry
 * here rather than another ternary in the page.
 *
 * `sourceParam` is the query param `/communication/conversations/` filters the
 * channel's source by (a WhatsApp number, a mailbox, a chatbot).
 */
export const CHANNEL_META = {
  [CHANNELS.WHATSAPP]: {
    label: "WhatsApp",
    sourceParam: "business_number",
    sourcePlaceholder: "All numbers",
    emptyText: "No WhatsApp conversations yet",
  },
  [CHANNELS.EMAIL]: {
    label: "Email",
    sourceParam: "mailbox",
    sourcePlaceholder: "All mailboxes",
    emptyText: "No email conversations yet",
  },
  [CHANNELS.CHAT]: {
    label: "Chat",
    sourceParam: "chatbot",
    sourcePlaceholder: "All chatbots",
    emptyText: "No website chats yet",
  },
};

export const metaFor = (channel) =>
  CHANNEL_META[channel] || CHANNEL_META[CHANNELS.WHATSAPP];

/** `{whatsapp: [], email: [], chat: []}` — the channel-sources shape. */
export const emptyChannelSources = () =>
  Object.values(CHANNELS).reduce((acc, key) => ({ ...acc, [key]: [] }), {});

export const CHAT_STATUS_COLOR = {
  open: "green",
  pending: "gold",
  resolved: "default",
};

export const CHANNEL_THEME = {
  [CHANNELS.WHATSAPP]: {
    accent: WA_GREEN,
    header: WA_HEADER_TEAL,
    background: WA_CHAT_BG,
    outboundBubble: WA_OUT_BUBBLE,
    inboundBubble: "#ffffff",
  },
  [CHANNELS.EMAIL]: {
    accent: EMAIL_BLUE,
    header: EMAIL_HEADER,
    background: EMAIL_CHAT_BG,
    outboundBubble: EMAIL_OUT_BUBBLE,
    inboundBubble: "#ffffff",
  },
  [CHANNELS.CHAT]: {
    accent: CHAT_VIOLET,
    header: CHAT_HEADER,
    background: CHAT_BG,
    outboundBubble: CHAT_OUT_BUBBLE,
    inboundBubble: "#ffffff",
  },
};

export const themeFor = (channel) =>
  CHANNEL_THEME[channel] || CHANNEL_THEME[CHANNELS.WHATSAPP];
